import { BreadNormalCss } from '@/styles/typography';
import { Link } from 'gatsby';
import styled from 'styled-components';

const Footer = styled.footer`
  width: 100%;
  margin-top: 49px;

  .ot-sdk-show-settings {
    color: ${({ theme }) => theme.colors.black} !important;
    font-weight: 325;
    font-family: Gotham;
    font-size: 12px !important;
    font-style: normal;
    line-height: 142%;
    border: none !important;
    background: none;
    padding: 0 !important;
    line-height: 142% !important;

    &:hover {
      background: none !important;
      color: ${({ theme }) => theme.colors.orangePeel} !important;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    margin-top: 72px;
  }
`;

const FooterFlex = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 40px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const ColumnsWrapper = styled.div<{ $wrap?: boolean }>`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
    flex-wrap: ${({ $wrap }) => ($wrap ? 'wrap' : 'nowrap')};
    gap: 4vw;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    gap: 4vw;
  }
`;

const AccordionWrapper = styled.div`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.lineGrey};
  padding: 24px 0;

  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.lineGrey};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    border: none;
    padding: 0;
    width: fit-content;

    &:last-child {
      border-bottom: none;
    }

    svg {
      display: none;
    }
  }
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-self: center;
  width: 100%;
`;

const AccordionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  padding-top: 16px;
`;

const Product = styled.a`
  display: flex;
  gap: 18px;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.lightGrey};
  border-radius: 6px;
  padding: 4px 12px;
  width: 100%;
  transition: background-color 0.3s ease;
  text-decoration: none;

  &:hover {
    background-color: #d2d2d2;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    max-width: 300px;
    min-width: 220px;
  }
`;

const Logo = styled.img`
  width: 152px;
  height: auto;
`;

const SomeLink = styled.a`
  width: 30px;
  height: 30px;
  border-radius: 50px;
  overflow: hidden;
  transition: all 0.2s ease-in-out;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.s}) {
    &:hover {
      transform: scale(1.2);
    }
  }
`;

const SomeImageWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.orangePeel};
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.lineGrey};
`;

const LangLink = styled(Link)<{ $active?: boolean }>`
  ${BreadNormalCss}
  text-decoration: none;
  color: ${({ theme, $active }) =>
    $active ? theme.colors.black : theme.colors.lineGrey};

  ${({ $active }) =>
    $active &&
    `
    pointer-events: none;
  `}
`;

const FormWrapper = styled.div`
  min-height: 200px;
  background-color: ${({ theme }) => theme.colors.lightGrey};
  border-radius: 6px;
  padding: 0 20px;
  width: 100%;
  margin: 27px 0 19px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;

  button {
    margin: 8px 0 0;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
      width: fit-content;
    }
  }
  @media screen and (min-width: 1430px) {
    min-width: 470px;
  }
`;

const S = {
  Footer,
  FooterFlex,
  ColumnsWrapper,
  AccordionWrapper,
  AccordionHeader,
  AccordionContent,
  Product,
  Logo,
  SomeLink,
  SomeImageWrapper,
  Line,
  LangLink,
  FormWrapper,
};

export default S;
